var React = require('react');

function DeviceType (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19.928 6.793c.55 0 .995.445.996.992v5.953a.995.995 0 0 1-.996.992h-2.99a.995.995 0 0 1-.996-.992V7.785c0-.547.446-.991.996-.992h2.99zm0-.992h-2.99c-1.1 0-1.992.888-1.992 1.984v5.953c0 1.095.892 1.984 1.992 1.984h2.99c1.1 0 1.992-.889 1.992-1.984V7.785a1.988 1.988 0 0 0-1.992-1.984zm-5.979 5.953H3.986a.995.995 0 0 1-.997-.993V2.825c0-.548.446-.991.997-.992h13.949c.55 0 .996.444.996.992v1.984h.997V2.825A1.988 1.988 0 0 0 17.935.841H3.985c-1.1 0-1.992.888-1.992 1.984v7.936c0 1.096.892 1.985 1.993 1.985H0c0 1.095.892 1.984 1.993 1.984h11.956v-2.976z","fill":"#F0626D"}));
}

DeviceType.defaultProps = {"width":"22","height":"16"};

module.exports = DeviceType;

DeviceType.default = DeviceType;
